<template>
  <div class="nodatabox">
    <div class="nodata"></div>
  </div>
</template>

<script>
    export default {
        name: "NoData"
    }
</script>

<style scoped lang="stylus">
.nodatabox
    position: fixed
    width: 100%
    height: 100%
    background-color: #F6F6F6
.nodata
    background: #F6F6F6 url("/static/tip-nodata.png") no-repeat center;
    background-size: 100%
    width: 4.81rem
    height: 3.36rem
    position: absolute
    left: 50%;
    top: 1.5rem;
    transform: translateX(-50%);
</style>



// WEBPACK FOOTER //
// src/components/NoData.vue